module.exports = __webpack_public_path__ + "static/img/204_TO8_2116_og.634dfa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/204_TO8_2116_og.jpg
// module id = xFLp
// module chunks = 0